/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiUpdateUserAdminDto } from '../models/jofi-update-user-admin-dto';
import { JofiUser } from '../models/jofi-user';

@Injectable({
  providedIn: 'root',
})
export class JofiAdminUsersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation usersAdminControllerFindAllPaginated
   */
  static readonly UsersAdminControllerFindAllPaginatedPath = '/v1/admin/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAdminControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerFindAllPaginated$Response(params?: {
    sortBy?: any;
    search?: any;
    limit?: any;
    page?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiUser>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminUsersService.UsersAdminControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('limit', params.limit, {});
      rb.query('page', params.page, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `usersAdminControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerFindAllPaginated(params?: {
    sortBy?: any;
    search?: any;
    limit?: any;
    page?: any;
    context?: HttpContext
  }
): Observable<Array<JofiUser>> {

    return this.usersAdminControllerFindAllPaginated$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiUser>>) => r.body as Array<JofiUser>)
    );
  }

  /**
   * Path part for operation usersAdminControllerFindAll
   */
  static readonly UsersAdminControllerFindAllPath = '/v1/admin/users/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAdminControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerFindAll$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiUser>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminUsersService.UsersAdminControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiUser>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `usersAdminControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerFindAll(params?: {
    context?: HttpContext
  }
): Observable<Array<JofiUser>> {

    return this.usersAdminControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiUser>>) => r.body as Array<JofiUser>)
    );
  }

  /**
   * Path part for operation usersAdminControllerFindById
   */
  static readonly UsersAdminControllerFindByIdPath = '/v1/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAdminControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerFindById$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiUser>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminUsersService.UsersAdminControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `usersAdminControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerFindById(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiUser> {

    return this.usersAdminControllerFindById$Response(params).pipe(
      map((r: StrictHttpResponse<JofiUser>) => r.body as JofiUser)
    );
  }

  /**
   * Path part for operation usersAdminControllerResendVerificationMail
   */
  static readonly UsersAdminControllerResendVerificationMailPath = '/v1/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAdminControllerResendVerificationMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerResendVerificationMail$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiUser>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminUsersService.UsersAdminControllerResendVerificationMailPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `usersAdminControllerResendVerificationMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerResendVerificationMail(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiUser> {

    return this.usersAdminControllerResendVerificationMail$Response(params).pipe(
      map((r: StrictHttpResponse<JofiUser>) => r.body as JofiUser)
    );
  }

  /**
   * Path part for operation usersAdminControllerDelete
   */
  static readonly UsersAdminControllerDeletePath = '/v1/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAdminControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerDelete$Response(params: {
    id: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiUser>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminUsersService.UsersAdminControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `usersAdminControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersAdminControllerDelete(params: {
    id: string;
    context?: HttpContext
  }
): Observable<JofiUser> {

    return this.usersAdminControllerDelete$Response(params).pipe(
      map((r: StrictHttpResponse<JofiUser>) => r.body as JofiUser)
    );
  }

  /**
   * Path part for operation usersAdminControllerUpdate
   */
  static readonly UsersAdminControllerUpdatePath = '/v1/admin/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAdminControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersAdminControllerUpdate$Response(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdateUserAdminDto
  }
): Observable<StrictHttpResponse<JofiUser>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminUsersService.UsersAdminControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `usersAdminControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersAdminControllerUpdate(params: {
    id: string;
    context?: HttpContext
    body: JofiUpdateUserAdminDto
  }
): Observable<JofiUser> {

    return this.usersAdminControllerUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<JofiUser>) => r.body as JofiUser)
    );
  }

}
